<template>
  <div>
    <div class="w-item" v-for="(item, index) in items" :key="item.id">
      <v-divider v-if="index > 0" />
      <div class="py-3">
        <div class="d-flex justify-space-between text-5">
          <span class="gray--text">Wallet Label</span>
          <span>{{ item.label }}</span>
        </div>
        <div class="d-flex justify-space-between text-5 mt-2">
          <span class="gray--text">Wallet Address</span>
          <span>{{ item.address | addr }}</span>
        </div>
        <div class="d-flex justify-space-between text-5 mt-2">
          <div class="d-flex align-center">
            <span class="gray--text">Connections</span>
            <v-tooltip bottom color="dark" max-width="260px">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="gray--text ml-1" v-bind="attrs" v-on="on"
                  >mdi-information</v-icon
                >
              </template>
              <span
                >Shows which Unagii product the connected wallet is interacting
                with.</span
              >
            </v-tooltip>
          </div>
          <div class="d-flex align-center">
            <div
              v-for="product in item.products"
              :key="product"
              :class="[
                `bg-${product}`,
                'w-product ml-2 text-uppercase black--text-abs',
              ]"
            >
              {{ product }}
            </div>
          </div>
        </div>
        <div class="d-flex justify-space-between text-5 mt-2">
          <span class="gray--text">Manage</span>
          <div class="d-flex">
            <v-tooltip bottom color="dark">
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="w-icon-circle mr-4"
                  v-bind="attrs"
                  v-on="on"
                  @click="toggleRenameWalletDialog(item)"
                >
                  <v-icon x-small>mdi-pencil</v-icon>
                </div>
              </template>
              <span>Rename wallet label</span>
            </v-tooltip>
            <v-tooltip bottom color="dark">
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="w-icon-circle mr-4"
                  v-bind="attrs"
                  v-on="on"
                  @click="copyAddress(item.address)"
                >
                  <v-icon x-small>far fa-clone</v-icon>
                </div>
              </template>
              <span>Copy wallet label</span>
            </v-tooltip>
            <v-tooltip
              bottom
              color="dark"
              v-if="projectByNetworkMap[item.coin_network]"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="w-icon-circle mr-4" v-bind="attrs" v-on="on">
                  <a
                    :href="
                      `${
                        projectByNetworkMap[item.coin_network].config
                          .explorerAddrLink
                      }${item.address}`
                    "
                    class="text-decoration-none d-flex"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <v-icon x-small>mdi-open-in-new</v-icon>
                  </a>
                </div>
              </template>
              <span>Open explorer</span>
            </v-tooltip>
            <v-tooltip bottom color="dark">
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="w-icon-circle"
                  v-bind="attrs"
                  v-on="on"
                  @click="toggleDeleteWalletDialog(item)"
                >
                  <v-icon x-small>mdi-connection</v-icon>
                </div>
              </template>
              <span>Disconnect wallet</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="editWalletDialog" max-width="300" persistent>
      <v-card v-if="selectedWalletItem">
        <v-card-title>
          <span class="headline">Rename wallet</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <div class="text-6 gray--text ml-4">Wallet name</div>
              <v-col cols="12">
                <v-text-field
                  class="c-input"
                  outlined
                  v-model="selectedWalletItem.label"
                  required
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="toggleRenameWalletDialog">Cancel</v-btn>
          <v-btn
            color="primary"
            text
            @click="renameWallet"
            :disabled="!selectedWalletItem.label.length"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteWalletDialog" persistent max-width="300">
      <v-card>
        <v-card-title class="headline">Disconnect this wallet?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="toggleDeleteWalletDialog">Cancel</v-btn>
          <v-btn color="primary" text @click="deleteWallet">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["items"],
  data: () => ({
    editWalletDialog: false,
    selectedWalletItem: null,
    deleteWalletDialog: false,
  }),
  computed: mapGetters({
    projectByNetworkMap: "projectConfig/projectByNetworkMap",
    walletList: "userWallets/walletList",
  }),
  methods: {
    toggleRenameWalletDialog(wallet) {
      if (this.selectedWalletItem) {
        this.selectedWalletItem = null;
        this.editWalletDialog = false;
        return;
      }
      this.selectedWalletItem = { ...wallet };
      this.editWalletDialog = true;
    },
    async renameWallet() {
      const payload = this.selectedWalletItem;
      this.toggleRenameWalletDialog();
      this.updateWallet(payload);
    },
    toggleDeleteWalletDialog(wallet) {
      if (!this.isUser && this.walletList.result.length <= 1) {
        return this.$store.dispatch("addAlert", {
          message: "Cannot disconnect the last wallet.",
          title: "Warning",
          type: "warning",
        });
      }
      if (this.selectedWalletItem) {
        this.selectedWalletItem = null;
        this.deleteWalletDialog = false;
        return;
      }
      this.selectedWalletItem = { ...wallet };
      this.deleteWalletDialog = true;
    },
    async deleteWallet() {
      const walletId = this.selectedWalletItem.id;
      this.toggleDeleteWalletDialog();
      await this.$store.dispatch("userWallets/deleteWallet", walletId);
      this.$store.dispatch("addAlert", {
        message: "Wallet deleted",
        title: "Success",
        type: "success",
      });
    },
    async updateWallet(payload) {
      try {
        await this.$store.dispatch("userWallets/updateWallet", payload);
      } catch (error) {
        this.$store.dispatch("addAlert", {
          message: error.message,
          type: "error",
          title: "Error",
        });
      }
    },
    copyAddress(address) {
      navigator.clipboard.writeText(address).then(() => {
        this.$store.dispatch("addAlert", {
          title: "Success",
          type: "success",
          message: "Wallet address copied to clipboard.",
        });
      });
    },
  },
  filters: {
    addr(value) {
      return value.slice(0, 8) + "..." + value.slice(-5);
    },
  },
};
</script>

<style lang="scss" scoped>
.w-item {
  .w-product {
    font-size: 10px;
    border-radius: 4px;
    padding: 2px 8px;
  }
  .w-icon-circle {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(249, 234, 232, 0.15);
    border: 1px solid #f9eae8;
    i::before {
      color: var(--gray);
    }
    &:hover {
      background: rgba(246, 96, 51, 0.1);
      i::before {
        color: var(--orange);
      }
    }
  }
}
</style>
